import {useEffect, useState} from "react";
import RestClientInstance from "../../../../lib/RestClient";

/*
 * Utility methods to fetch master data from server.
 * Currently only for Market Nr <-> Market Name translation. Refactor as needed when there is more master data available.
 */

interface MarketData {
  loaded: boolean,
  pendingPromise?: Promise<any>,
  markets: {[key: string]: string}
}

const marketData: MarketData = {
  loaded: false,
  pendingPromise: undefined,
  markets: {}
};

/**
 * Returns a promise which resolves to the market name of the given marketNr or an empty string when marketNr is not found.
 * Fetches market master data from server or uses cache as data does not change often.
 *
 * @param marketNr
 */
const getMarket = (marketNr: string): Promise<string> => {
  const handleResponse = () => {
    return marketData.markets[marketNr] || '';
  };
  if(!marketData.loaded && marketData.pendingPromise) {
    return marketData.pendingPromise.then(handleResponse);
  } else if(marketData.loaded) {
    return new Promise(resolve => {
      resolve(handleResponse());
    });
  } else {
    marketData.pendingPromise = RestClientInstance.get('master-data/markets')
      .then(response => {
        marketData.markets = response.data.reduce((agg: any, market: any) => {
          return {...agg, [market.markt]: market.kurzname}
        }, {});
        marketData.loaded = true;
        marketData.pendingPromise = undefined;
      }).catch(e => {
        marketData.loaded = false;
        marketData.pendingPromise = undefined;
      });
    marketData.loaded = false;
    return marketData.pendingPromise.then(handleResponse);
  }
};

/**
 * React hook wrapping getMarket
 */
export const useMarketName = (marktNr: string) => {
  const [marketName, setMarketName] = useState('');
  useEffect(() => {
    getMarket(marktNr).then(market => {
      setMarketName(market);
    })
  }, [marktNr]);
  return marketName;
};
